import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';

// Tabs
import DetailsTab from "./Tabs/Details";

  const tabContent = [
    {panel: "details", content: <DetailsTab />},
   
  ]

const ViewContactGroup = () => {

  const tabs = [
    {label: "Details", icon: <ContactPageOutlinedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Contact Group" identifier="name" tabs={tabs} tabContent={tabContent} isProfile={true} url="contact_groups" isProfile={false}>

    </ViewDetails>
  )
};

export default ViewContactGroup;